// extracted by mini-css-extract-plugin
module.exports = {"type-listicle":"TileBanner_type-listicle__5DHtV","wideTile":"TileBanner_wideTile__izBJT"};